import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import { getAuthorableCopy } from '../../queries';
import SlotNotificationAuthorable from './SlotNotificationAuthorable';

function SlotNotificationAuthorableVM({
  slot,
  currentPage,
  ...props
}) {
  const isAuthorableMessagesEnabled = !!window?.FLAGS?.AuthorableMessages;
  const { loading, error, data } = useQuery(getAuthorableCopy, {
    skip: !isAuthorableMessagesEnabled,
  });

  let currentNotifications;

  if (isAuthorableMessagesEnabled) {
    if (data && !loading && !error) {
      const authorableData = data.getAuthorableCopy;

      const matchIdNotifications = authorableData.filter(
        (item) => parseInt(item.contentId, 10) === slot,
      );
      currentNotifications = matchIdNotifications.filter(
        (item) => item.page === currentPage ?? item[0],
      );
    }

    if (loading) return <p>Loading...</p>;
    if (error) return null;

    const mapProps = {
      currentNotifications,
      ...props,
    };

    return <SlotNotificationAuthorable {...mapProps} />;
  }

  return null;
}

SlotNotificationAuthorableVM.propTypes = {
  slot: PropTypes.number.isRequired,
  currentPage: PropTypes.string.isRequired,
};

export default SlotNotificationAuthorableVM;
